import { render, staticRenderFns } from "./MeetingType.vue?vue&type=template&id=70745c66&scoped=true&"
import script from "./MeetingType.vue?vue&type=script&lang=js&"
export * from "./MeetingType.vue?vue&type=script&lang=js&"
import style0 from "./MeetingType.vue?vue&type=style&index=0&id=70745c66&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70745c66",
  null
  
)

export default component.exports